<script>
import { mapState, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
   components: {
      VueApexCharts,
   },
   data() {
      return {
         isLoading: false,
      }
   },
   computed: {
      ...mapState({
         jenisKelamin: state => state.DashboardMppd.jenisKelamin,
         tahun: state => state.DashboardMppd.tahun,
         refreshTimestamp: state => state.DashboardMppd.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      chartSeries() {
         return [
            Number(this.jenisKelamin.l) || 0,
            Number(this.jenisKelamin.p) || 0,
         ]
      },
      chartOptions() {
         const textColor = this.isDark ? '#d0d2d6' : '#5e5873'
         const bgColor = this.isDark ? '#283046' : '#ffffff'

         return {
            chart: {
               type: 'donut',
               foreColor: textColor,
               toolbar: {
                  show: false,
               },
               fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
            },
            labels: ['Laki-laki', 'Perempuan'],
            colors: ['#7367f0', '#ea5455'],
            dataLabels: {
               enabled: false,
            },
            stroke: {
               show: true,
               curve: 'smooth',
               lineCap: 'round',
               colors: [bgColor],
               width: 6,
            },
            plotOptions: {
               pie: {
                  donut: {
                     size: '65%',
                     labels: {
                        show: true,
                        name: {
                           show: true,
                           fontSize: '14px',
                           color: textColor,
                        },
                        value: {
                           show: true,
                           fontSize: '22px',
                           fontWeight: 700,
                           color: textColor,
                           formatter: value => Number(value).toLocaleString('id-ID'),
                        },
                        total: {
                           show: true,
                           showAlways: true,
                           label: 'Total',
                           fontSize: '14px',
                           color: this.isDark ? '#b4b7bd' : '#6e6b7b',
                           formatter: w => Number(w.globals.seriesTotals.reduce((a, b) => a + b, 0)).toLocaleString('id-ID'),
                        },
                     },
                  },
               },
            },
            legend: {
               position: 'bottom',
               labels: {
                  colors: textColor,
               },
            },
            tooltip: {
               theme: this.isDark ? 'dark' : 'light',
               y: {
                  formatter: value => `${Number(value).toLocaleString('id-ID')} orang`,
               },
            },
         }
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadData(newYear)
      },
      refreshTimestamp() {
         this.loadData(this.tahun)
      },
   },
   mounted() {
      this.loadData(this.tahun)
   },
   methods: {
      ...mapActions({
         getJenisKelamin: 'DashboardMppd/getJenisKelamin',
      }),
      async loadData(year) {
         if (this.isLoading) return
         this.isLoading = true
         try {
            await this.getJenisKelamin(year)
         } finally {
            this.isLoading = false
         }
      },
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card class="card-wrapper">
            <div class="d-flex justify-content-between align-items-center mb-1">
               <div>
                  <h4 class="mb-25">
                     Jenis Kelamin
                  </h4>
                  <small class="text-muted">Tahun {{ tahun }}</small>
               </div>
               <b-spinner v-if="isLoading" small variant="primary" />
            </div>
            <vue-apex-charts
               type="donut"
               height="350"
               :options="chartOptions"
               :series="chartSeries"
            />
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}

.dark-layout .card-wrapper {
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}
</style>
